module.exports = __webpack_public_path__ + "static/media/Shrishti Ko Geet Part 1 V2.87afe99d.mp4";